import { Controller } from "@hotwired/stimulus";
import { handleDropzoneUploadSuccess } from "../../components/dropzone";
import { toggleClass } from "../../utils/misc";
import { flashAlert } from "../../components/flash_alert";
import { updateBankTransactionsTableRows } from "../../datatables/bank_transactions_datatable";

export default class extends Controller {
  static targets = ["submitBtn"];
  static outlets = ["basic-file-upload"];

  connect() {
    this.dropzone = this.basicFileUploadOutlet.dropzone;

    this._initDropzoneEvents();
  }

  _initDropzoneEvents() {
    this.dropzone.on("addedfiles", () => {
      this._toggleSubmitBtn();
    });

    this.dropzone.on("removedfile", () => {
      this._toggleSubmitBtn();
    });

    handleDropzoneUploadSuccess(this.dropzone, this.element);
  }

  validateSubmission(e) {
    e.preventDefault();
    this.dropzone.processQueue();
  }

  _toggleSubmitBtn() {
    const hasAcceptedFiles = this.dropzone.files.length > 0;
    toggleClass(this.submitBtnTarget, "hidden", hasAcceptedFiles);
  }

  fileAttached(e) {
    const data = JSON.parse(e.detail[0].response);
    flashAlert(data.message);
    updateBankTransactionsTableRows([data.bank_transaction]);
  }
}
